import { Device } from "@models";
import { useMemo } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { sortDevicesByName } from "src/utils/sorting";

export const getFallbackDeviceId = (devices: Device[]) =>
  sortDevicesByName(devices)[0]?.id ?? null;

const getValidDeviceId = ({
  deviceId,
  devices,
}: {
  deviceId?: string | null;
  devices: Device[];
}) =>
  deviceId && devices.some((device) => device.id === deviceId) ? deviceId : null;

export const getPreferredDeviceId = ({
  devices,
  fallbackDevices,
  preferredDeviceId,
  queryDeviceId,
  routeDeviceId,
}: {
  devices: Device[];
  fallbackDevices?: Device[];
  preferredDeviceId?: string | null;
  queryDeviceId: string | null;
  routeDeviceId: string | null;
}) =>
  getValidDeviceId({
    deviceId: preferredDeviceId,
    devices,
  }) ||
  getValidDeviceId({
    deviceId: routeDeviceId,
    devices,
  }) ||
  getValidDeviceId({
    deviceId: queryDeviceId,
    devices,
  }) ||
  getFallbackDeviceId(fallbackDevices ?? devices);

export const useDocumentRouteSelection = () => {
  const { deviceId: routeDeviceId = "", docId: routeDocumentId = "" } =
    useParams();
  const [searchParams] = useSearchParams();
  const queryDeviceId = searchParams.get("deviceId");
  const queryDocumentId = searchParams.get("d");
  const documentId = routeDocumentId || queryDocumentId;

  return useMemo(
    () => ({
      documentId,
      queryDeviceId,
      routeDeviceId,
    }),
    [documentId, queryDeviceId, routeDeviceId]
  );
};
